import { HelperArticle } from "@tudigo-monorepo/core-tudigo-api-models";
import { cn } from "@tudigo-monorepo/core-tudigo-theme";

import { ArticleStatus } from "../types/article.types";
import { getArticleComponentByCMSBlock } from "../utils/get-article-component-by-cms-block";

export interface ArticleDetailProps {
  article: HelperArticle;
}

export function ArticleDetail({ article }: ArticleDetailProps) {
  return (
    <article className="rounded-[1px] border border-neutral-200 bg-neutral-50 p-6">
      <h2 className="body500-medium text-primary-600 mb-4">{article.name}</h2>

      {article.status !== ArticleStatus.Published && (
        <div className="mb-4">
          <span
            className={cn(
              "inline-block rounded-full px-2 py-1 text-xs",
              article.status === ArticleStatus.Draft
                ? "bg-amber-100 text-amber-800"
                : "bg-blue-100 text-blue-800",
            )}
          >
            {article.status === ArticleStatus.Draft
              ? "Brouillon"
              : "En révision"}
          </span>
        </div>
      )}

      <div className="body400-regular mb-6 text-neutral-700">
        {article.description}
      </div>

      <div>
        {article.content
          .map((block) => getArticleComponentByCMSBlock(block))
          .map((Block, index) => (
            <Block key={index} />
          ))}
      </div>
    </article>
  );
}
